import React from 'react';
import styles from './ServerError.module.scss';

export default function ServerError() {
    return (
        <div className={styles.page}>
            <div className={styles.content}>
                <h1 className={styles.errorCode}>500</h1>

                <div className={styles.divider} />

                <h2 className={styles.title}>Eitthvað fór úrskeiðis</h2>
                <p className={styles.description}>
                    Við biðjumst innilega afsökunar — eitthvað fór úrskeiðis hjá okkur. Forritarar
                    okkar hafa verið látnir vita. Vinsamlega reyndu aftur eða hafðu samband við{' '}
                    <a href="mailto:spara@spara.is" style={{ color: 'inherit', fontWeight: 600 }}>
                        spara@spara.is
                    </a>{' '}
                    ef vandinn heldur áfram.
                </p>

                <button
                    className={styles.button}
                    onClick={() => {
                        window.location.href = '/';
                    }}
                >
                    Fara á forsíðu
                </button>
            </div>
        </div>
    );
}
